import { patchDashSocialA11y } from "../utilities/Helpers/UI/DashSocialA11y";

// Loaded only by sections/clean-html.liquid, and only when its HTML embeds
// the Dash Social carousel, so the patch stays out of main.js and off every
// other section. The carousel renders client-side, so the patch's own
// observer handles it appearing later.
patchDashSocialA11y();
